import * as React from "react";
import type { SVGProps } from "react";
const SvgBackicon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 13 23"
    {...props}
  >
    <path
      fill="#fff"
      d="M2.8 15v-2.4h2.4V15zm0-4.8v2.4H.4v-2.4zm0-2.4h2.4v2.4H2.8zM7.6 15v2.4H5.2V15zm0 2.4H10v2.4H7.6zm0-12V3H10v2.4zm0 2.4H5.2V5.4h2.4zm4.8 14.4H10v-2.4h2.4zm0-19.2H10V.6h2.4z"
    />
  </svg>
);
export default SvgBackicon;
